import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import {
  NoCreditCheckCircleIcon,
  SamePriceCircleIcon,
  BigCarrierReachCircleIcon,
  RealHumansCircleIcon,
} from '../../../images/svg';

const FiberTrustSection = ({ phoneNumber, speedDisclaimer }) => {
  const { t } = useTranslation();

  const trustItems = [
    { title: t('products.fiberTrustNoCreditTitle'), desc: t('products.fiberTrustNoCreditDesc'), Icon: NoCreditCheckCircleIcon },
    { title: t('products.fiberTrustSamePriceTitle'), desc: t('products.fiberTrustSamePriceDesc'), Icon: SamePriceCircleIcon },
    { title: t('products.fiberTrustReachTitle'), desc: t('products.fiberTrustReachDesc'), Icon: BigCarrierReachCircleIcon },
    { title: t('products.fiberTrustSupportTitle'), desc: t('products.fiberTrustSupportDesc'), Icon: RealHumansCircleIcon },
  ];

  return (
    <section className="fiber-trust">
      <div className="elink-container">
        <div className="fiber-trust__heading">
          <p className="fiber-trust__eyebrow">{t('products.fiberTrustEyebrow')}</p>
          <h2 className="fiber-trust__title">{t('products.fiberTrustTitle')}</h2>
        </div>

        <div className="fiber-trust__grid">
          {trustItems.map(({ title, desc, Icon }) => (
            <div key={title} className="fiber-trust__item">
              <div className="fiber-trust__iconWrap" aria-hidden="true">
                <Icon />
              </div>
              <h3 className="fiber-trust__itemTitle">{title}</h3>
              <p className="fiber-trust__itemDesc">{desc}</p>
            </div>
          ))}
        </div>

        <div className="fiber-trust__ctaBanner">
          <div className="fiber-trust__ctaText">
            <h3 className="fiber-trust__ctaTitle">{t('products.fiberTrustCtaTitle')}</h3>
            <p className="fiber-trust__ctaBody">{t('products.fiberTrustCtaBody')}</p>
          </div>
          <div className="fiber-trust__ctaPhone">
            <a className="fiber-trust__ctaPhoneBtn" href={`tel:${phoneNumber}`}>
              {phoneNumber}
            </a>
            <p className="fiber-trust__ctaFooter">{t('products.fiberTrustCtaFooter')}</p>
          </div>
        </div>

        <p className="fiber-trust__disclaimer">{speedDisclaimer || t('products.disclaimerSpeed')}</p>
      </div>
    </section>
  );
};

FiberTrustSection.propTypes = {
  phoneNumber: PropTypes.string.isRequired,
  speedDisclaimer: PropTypes.string,
};

export default FiberTrustSection;
